import * as React from 'react';
import {
  Datagrid,
  List,
  ListProps,
  TextField,
  useTranslate,
  useGetIdentity,
  DateField,
} from 'react-admin';
import TestTypeField from '../../../components/Fields/TestTypeField';
import PartnerField from '../../../components/Fields/PartnerField';
import Paginator from '../../../components/Paginator';
import { TESTS_PER_PAGE } from '../../../constants/pagination';

import './styles.scss';

const ReviewedImmunotherapyTestsList = (props: ListProps) => {
  const translate = useTranslate();
  const { identity } = useGetIdentity();
  const isAdmin = identity?.userRoles?.includes('admin');

  return (
    <List
      {...props}
      bulkActionButtons={false}
      actions={false}
      empty={<div className="error">{translate('testResults.noTests')}</div>}
      pagination={<Paginator perPage={TESTS_PER_PAGE} />}
      perPage={TESTS_PER_PAGE}
    >
      <Datagrid rowClick="show">
        <TestTypeField source="type" label="tests.type" />
        {isAdmin && (
          <TextField
            sortable={false}
            emptyText="-"
            source="code"
            label="tests.code"
          />
        )}
        {!isAdmin && (
          <TextField
            sortable={false}
            emptyText="-"
            source="user.dateOfBirth"
            label="tests.dateOfBirth"
          />
        )}
        {isAdmin && (
          <PartnerField source="partnerCode" label="tests.columns.partners" />
        )}
        <TextField
          sortable={false}
          emptyText="-"
          source="user.initials"
          label="tests.initials"
        />
        <DateField
          showTime
          sortable={false}
          emptyText="-"
          source="reviewCompletedAt"
          label="tests.reviewCompletedAt"
        />
      </Datagrid>
    </List>
  );
};

export default ReviewedImmunotherapyTestsList;

export const FERTILITY_CHECK_MODULE = 'tests/fertility-check';
